(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const root = (window.GGSTORE && window.GGSTORE.root) || '/';
  const strings = (window.GGSTORE && window.GGSTORE.strings) || {};
  /* Uses the store's own money_format so JS prices match every Liquid-rendered
     price on the page (QAR 319,00), in Arabic as well as English. */
  const money = (cents) => {
    const fmt = (window.GGSTORE && GGSTORE.moneyFormat) || 'QAR {{amount}}';
    const build = (decimals, thousands, decimal) => {
      const parts = ((Number(cents) || 0) / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals ? parts[0] + decimal + parts[1] : parts[0];
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, name) => {
      switch (name) {
        case 'amount_no_decimals': return build(0, ',', '');
        case 'amount_with_comma_separator': return build(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return build(0, '.', '');
        case 'amount_with_apostrophe_separator': return build(2, "'", '.');
        case 'amount_with_space_separator': return build(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return build(0, ' ', '');
        default: return build(2, ',', '.');
      }
    });
  };
  let openLayers = 0;
  const lock = (state) => {
    openLayers = Math.max(0, openLayers + (state ? 1 : -1));
    document.body.classList.toggle('is-locked', openLayers > 0);
  };
  const unlockAll = () => { openLayers = 0; document.body.classList.remove('is-locked'); };
  const openLayer = (el, trigger) => { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden','false'); trigger?.setAttribute('aria-expanded','true'); lock(true); };
  const closeLayer = (el, trigger) => { if (!el || !el.classList.contains('is-open')) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden','true'); trigger?.setAttribute('aria-expanded','false'); lock(false); };

  /* Doha delivery status */
  function updateDeliveryMessage(){
    try{
      const parts = new Intl.DateTimeFormat('en-GB',{timeZone:'Asia/Qatar',hour:'2-digit',hour12:false}).formatToParts(new Date());
      const hour = Number(parts.find(p=>p.type==='hour')?.value || 0);
      const txt = hour < Number(GGSTORE.cutoff || 20) ? GGSTORE.sameDayText : GGSTORE.lateDeliveryText;
      $$('[data-delivery-message]').forEach(el => {
        const target = el.matches('[data-delivery-message]') && el.children.length ? el.lastElementChild : el;
        if(target) target.textContent = txt;
      });
    }catch(e){}
  }
  updateDeliveryMessage();

  /* Mobile navigation */
  const mobileMenu = $('[data-mobile-menu]');
  const mobileMenuTrigger = $('[data-menu-open]');
  mobileMenuTrigger?.addEventListener('click',()=>openLayer(mobileMenu,mobileMenuTrigger));
  $$('[data-menu-close]').forEach(x=>x.addEventListener('click',()=>closeLayer(mobileMenu,mobileMenuTrigger)));
  $$('[data-mobile-subnav-toggle]').forEach(toggle=>toggle.addEventListener('click',()=>{
    const panel=toggle.parentElement?.querySelector('[data-mobile-subnav]');
    const open=toggle.getAttribute('aria-expanded')==='true';
    toggle.setAttribute('aria-expanded',String(!open));
    toggle.parentElement?.classList.toggle('is-open',!open);
    if(panel) panel.hidden=open;
  }));

  /* Search + predictive search */
  const searchPanel = $('[data-search-panel]');
  const predictiveInput = $('[data-predictive-input]');
  const predictiveResults = $('[data-predictive-results]');
  const searchTrigger=$('[data-search-open]');
  searchTrigger?.addEventListener('click',()=>{ openLayer(searchPanel,searchTrigger); setTimeout(()=>predictiveInput?.focus(),220); });
  $$('[data-search-close]').forEach(x=>x.addEventListener('click',()=>closeLayer(searchPanel,searchTrigger)));
  let searchTimer;
  predictiveInput?.addEventListener('input',()=>{
    clearTimeout(searchTimer);
    const q = predictiveInput.value.trim();
    if(q.length < 2){ predictiveResults.innerHTML=''; return; }
    searchTimer=setTimeout(async()=>{
      try{
        const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last`;
        const res=await fetch(url,{headers:{Accept:'application/json'}}); const data=await res.json();
        const r=data.resources?.results||{}; const products=r.products||[], collections=r.collections||[], pages=r.pages||[];
        const links=[...collections,...pages];
        predictiveResults.innerHTML=`<div class="gg-predictive-grid"><div><h3>${escapeHtml(strings.searchExplore||'Explore')}</h3><div class="gg-predictive-links">${links.slice(0,7).map(i=>`<a href="${i.url}">${escapeHtml(i.title)}</a>`).join('') || `<span class="gg-predictive-empty">${escapeHtml(strings.searchTry||'Try a product or brand name')}</span>`}<a href="${root}search?q=${encodeURIComponent(q)}">${escapeHtml(strings.searchAll||'See all search results')} →</a></div></div><div><h3>${escapeHtml(strings.searchProducts||'Products')}</h3><div class="gg-predictive-products">${products.slice(0,6).map(p=>{const img=p.image && (p.image.url||p.image); return `<a class="gg-predictive-product" href="${p.url}">${img?`<img src="${img}" alt="">`:''}<div><strong>${escapeHtml(p.title)}</strong><span>${money(p.price)}</span></div></a>`}).join('') || `<span class="gg-predictive-empty">${escapeHtml(strings.searchNoProducts||'No products yet')}</span>`}</div></div></div>`;
      }catch(e){ predictiveResults.innerHTML=`<p class="gg-predictive-empty">${escapeHtml(strings.searchUnavailable||'Search is temporarily unavailable.')}</p>`; }
    },180);
  });

  /* Cart */
  const drawer=$('[data-cart-drawer]'), cartItems=$('[data-cart-items]'), cartFooter=$('[data-cart-footer]');
  /* item.image may arrive without a query string, so ?/& must be chosen. */
  const sized = (url, w) => url + (url.includes('?') ? '&' : '?') + 'width=' + w;
  async function getCart(){ const r=await fetch(`${root}cart.js`,{headers:{Accept:'application/json'}}); return r.json(); }
  async function renderCart(open=true){
    try{
      const cart=await getCart();
      $$('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
      if(cart.item_count===0){
        if(cartItems) cartItems.innerHTML=`<div class="gg-cart-empty"><h3>${escapeHtml(strings.cartEmptyTitle||'Your cart is empty')}</h3><p>${escapeHtml(strings.cartEmptyText||'Ready for your next setup upgrade?')}</p></div>`;
        if(cartFooter) cartFooter.hidden=true;
      }else{
        if(cartFooter) cartFooter.hidden=false;
        if(cartItems) cartItems.innerHTML=cart.items.map(item=>`<div class="gg-cart-drawer-item"><a href="${item.url}">${item.image?`<img src="${sized(item.image,180)}" alt="" loading="lazy">`:''}</a><div><a class="gg-cart-item-title" href="${item.url}">${escapeHtml(item.product_title)}</a>${item.variant_title?`<p class="gg-cart-item-variant">${escapeHtml(item.variant_title)}</p>`:''}<div class="gg-cart-item-qty"><button type="button" data-cart-change="${item.key}" data-delta="-1">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${item.key}" data-delta="1">+</button></div><button type="button" class="gg-cart-item-remove" data-cart-remove="${item.key}">${escapeHtml(strings.remove||'Remove')}</button></div><span class="gg-cart-item-price">${money(item.final_line_price)}</span></div>`).join('');
        $('[data-cart-subtotal]') && ($('[data-cart-subtotal]').textContent=money(cart.total_price));
      }
      const threshold=Number(GGSTORE.shippingThreshold||0), progress=$('[data-cart-progress]');
      if(progress && threshold>0){ const remaining=Math.max(threshold-cart.total_price,0), pct=Math.min((cart.total_price/threshold)*100,100); progress.innerHTML=`<div>${remaining>0?escapeHtml((strings.awayFromFreeDelivery||'{{ amount }} away from free delivery').replace('{{ amount }}',money(remaining))):escapeHtml(strings.freeDeliveryReached||'You’ve reached the free-delivery threshold')}</div><div class="gg-progress-bar"><span style="width:${pct}%"></span></div>`; }
      if(open) openLayer(drawer);
    }catch(e){ console.error('GGSTORE cart:',e); }
  }
  $('[data-cart-open]')?.addEventListener('click',()=>renderCart(true));
  $$('[data-cart-close]').forEach(x=>x.addEventListener('click',()=>closeLayer(drawer)));
  document.addEventListener('click',async(e)=>{
    const rm=e.target.closest('[data-cart-remove]');
    if(rm){ rm.disabled=true;
      try{ await fetch(`${root}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:rm.dataset.cartRemove,quantity:0})}); await renderCart(false); }
      catch(err){ rm.disabled=false; }
      return; }
    const q=e.target.closest('[data-cart-change]'); if(!q)return;
    const item=$$('.gg-cart-drawer-item').find(el=>el.contains(q)); const qtyEl=item?.querySelector('.gg-cart-item-qty span');
    const current=Number(qtyEl?.textContent||1), quantity=Math.max(0,current+Number(q.dataset.delta));
    q.disabled=true;
    try{await fetch(`${root}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:q.dataset.cartChange,quantity})});await renderCart(false)}catch(err){q.disabled=false}
  });
  async function addVariant(id,quantity=1,button){
    if(!id)return;
    const old=button?.innerHTML; if(button){button.disabled=true;button.innerHTML=escapeHtml(strings.adding||'Adding…');}
    try{
      const res=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:Number(quantity)||1}]})});
      if(!res.ok) throw new Error((await res.json()).description||'Unable to add item');
      await renderCart(GGSTORE.cartDrawer !== false);
      if(button){button.innerHTML=escapeHtml(strings.added||'Added ✓');setTimeout(()=>{button.disabled=false;button.innerHTML=old},900)}
    }catch(err){ if(button){button.disabled=false;button.innerHTML=old;} alert(err.message||'Unable to add this product.'); }
  }
  document.addEventListener('click',(e)=>{ const b=e.target.closest('.gg-quick-add'); if(b){e.preventDefault();addVariant(b.dataset.variantId,1,b);} });

  /* Product page */
  const productSection=$('[data-product-section]');
  if(productSection){
    const variants=JSON.parse($('[data-product-json]',productSection)?.textContent||'[]');
    const select=$('[data-variant-select]',productSection), idInput=$('[data-variant-id-input]',productSection), add=$('[data-add-to-cart]',productSection), stickyAdd=$('[data-sticky-add]',productSection), qty=$('.gg-quantity input',productSection);
    const syncVariant=(id)=>{
      const v=variants.find(x=>String(x.id)===String(id)); if(!v)return;
      idInput.value=v.id; if(select && select.value!==String(v.id)) select.value=String(v.id);
      const current=$('.gg-price-current',$('[data-product-price]',productSection)); const compare=$('.gg-price-compare',$('[data-product-price]',productSection));
      if(current) current.textContent=money(v.price);
      const onSale = !!(v.compare_at_price && v.compare_at_price > v.price);
      if(compare){ compare.textContent = onSale ? money(v.compare_at_price) : ''; compare.hidden = !onSale; }
      const priceWrap = $('.gg-price', $('[data-product-price]',productSection));
      if(priceWrap) priceWrap.classList.toggle('is-sale', onSale);
      $('[data-sticky-price]',productSection) && ($('[data-sticky-price]',productSection).textContent=money(v.price));
      [add,stickyAdd].forEach(b=>{if(b){b.disabled=!v.available; const txt=b.querySelector('[data-add-text]'); if(txt)txt.textContent=v.available?(strings.addToCart||'Add to cart'):(strings.soldOut||'Sold out'); else b.textContent=v.available?(strings.addToCart||'Add to cart'):(strings.soldOut||'Sold out');}});
      const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);
      if(v.featured_media){ const thumb=$(`[data-media-target="${v.featured_media.id}"]`,productSection); thumb?.click(); }
    };
    select?.addEventListener('change',()=>syncVariant(select.value));
    $('[data-qty-minus]',productSection)?.addEventListener('click',()=>qty.value=Math.max(1,Number(qty.value||1)-1));
    $('[data-qty-plus]',productSection)?.addEventListener('click',()=>qty.value=Number(qty.value||1)+1);
    $('form.gg-product-form',productSection)?.addEventListener('submit',(e)=>{if(e.submitter && e.submitter.name && e.submitter.name!=='add')return;e.preventDefault();addVariant(idInput.value,qty.value,add)});
    stickyAdd?.addEventListener('click',()=>addVariant(idInput.value,qty?.value||1,stickyAdd));
    $$('[data-media-target]',productSection).forEach((t,index)=>t.addEventListener('click',()=>{ $$('[data-media-target]',productSection).forEach(x=>x.classList.remove('is-active'));$$('[data-media-id]',productSection).forEach(x=>x.classList.remove('is-active'));t.classList.add('is-active');$(`[data-media-id="${t.dataset.mediaTarget}"]`,productSection)?.classList.add('is-active'); const counter=$('[data-media-current]',productSection); if(counter)counter.textContent=String(index+1); }));
    if(stickyAdd){ const observer=new IntersectionObserver(entries=>stickyAdd.closest('[data-mobile-sticky]')?.classList.toggle('is-visible',!entries[0].isIntersecting),{threshold:.1}); if(add)observer.observe(add); }
  }


  /* Automatic newest-products feed (server-rendered by Shopify) */
  $$('[data-auto-newest]').forEach(async grid=>{
    const count=Math.max(1,Number(grid.dataset.autoNewestCount||8));
    const source=grid.dataset.autoNewestUrl;
    if(!source)return;
    try{
      const url=new URL(source,window.location.origin);
      url.searchParams.set('sort_by','created-descending');
      url.searchParams.set('section_id','main');
      const response=await fetch(url.toString(),{headers:{'X-Requested-With':'XMLHttpRequest'}});
      if(!response.ok)return;
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const cards=[...doc.querySelectorAll('.gg-collection-products .gg-product-card')].slice(0,count);
      if(cards.length){
        const fragment=document.createDocumentFragment();
        cards.forEach(card=>fragment.appendChild(document.importNode(card,true)));
        grid.replaceChildren(fragment);
      }
    }catch(e){ /* Keep Liquid-rendered fallback products. */ }
  });

  /* Recommendations */
  const recommendations=$('[data-recommendations]');
  if(recommendations && !recommendations.innerHTML.trim()) fetch(recommendations.dataset.url).then(r=>r.text()).then(html=>{const doc=new DOMParser().parseFromString(html,'text/html');const fresh=doc.querySelector('[data-recommendations]');if(fresh?.innerHTML.trim())recommendations.innerHTML=fresh.innerHTML}).catch(()=>{});

  /* Collection */
  const filterSidebar=$('[data-filter-sidebar]');
  $('[data-filter-open]')?.addEventListener('click',()=>{filterSidebar?.classList.add('is-open');document.body.classList.add('filter-is-open');lock(true)});
  $$('[data-filter-close]').forEach(x=>x.addEventListener('click',()=>{filterSidebar?.classList.remove('is-open');document.body.classList.remove('filter-is-open');lock(false)}));
  $$('[data-price-input]').forEach(input=>input.addEventListener('input',()=>{
    let value=String(input.value||'').replace(/\D/g,'').replace(/^0+(?=\d)/,'');
    const max=Number(input.dataset.priceMax||0);
    if(value && max>0 && Number(value)>max) value=String(max);
    input.value=value;
  }));
  $('[data-sort-select]')?.addEventListener('change',(e)=>{const url=new URL(location.href);url.searchParams.set('sort_by',e.target.value);location.href=url.toString()});

  document.addEventListener('keydown',(e)=>{if(e.key==='Escape'){closeLayer(searchPanel,searchTrigger);closeLayer(drawer);closeLayer(mobileMenu,mobileMenuTrigger);filterSidebar?.classList.remove('is-open');document.body.classList.remove('filter-is-open');unlockAll()}});
  function escapeHtml(str=''){return String(str).replace(/[&<>'"]/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[m]))}
})();
